import * as React from 'react';

function SvgDocumentIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 20 20"
      {...props}>
      <path
        stroke="#0C3998"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M5 1.75h6.5L15.75 6v11.25a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V2.75a1 1 0 0 1 1-1Z"
      />
      <path
        stroke="#0C3998"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M11.25 2v3.75c0 .414.336.75.75.75h3.5"
      />
      <path
        stroke="#0C3998"
        strokeLinecap="round"
        strokeWidth={1.5}
        d="M6.75 10H13M6.75 13H13"
      />
    </svg>
  );
}
export default SvgDocumentIcon;
